import * as React from "react";
import { useRef } from "react";
import { motion, useCycle } from "framer-motion";
import { useDimensions } from "./use-dimensions";
import { MenuToggle } from "./MenuToggle"; // Ensure MenuToggle doesn't have its own circle
import { Navigation } from "./Navigation";

const sidebar = {
  open: (height = 1000) => ({
    clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
    transition: {
      type: "spring",
      stiffness: 20,
      restDelta: 2
    }
  }),
  closed: {
    clipPath: "circle(30px at 40px 40px)",
    transition: {
      delay: 0.5,
      type: "spring",
      stiffness: 400,
      damping: 40
    }
  }
};

export const Example = () => {
  const [isOpen, toggleOpen] = useCycle(false, true);
  const containerRef = useRef(null);
  const { height } = useDimensions(containerRef);

  return (
    <motion.nav
      initial={false}
      animate={isOpen ? "open" : "closed"}
      custom={height}
      ref={containerRef}
      className="relative w-full h-64 bg-white border rounded-xl overflow-hidden"
    >
      <motion.div className="absolute top-0 left-0 bottom-0 w-full bg-blue-200 z-10" variants={sidebar} />
      <Navigation />

      {/* Removed the extra circle styling */}
      <div className="relative w-16 h-16 flex items-center justify-center">
        {/* MenuToggle: Make sure it's not a circle */}
        <MenuToggle toggle={() => toggleOpen()} />
      </div>

      <p className="text-center text-gray-500 mt-4 text-sm">
      </p>
    </motion.nav>
  );
};
